import type {MarketId, ProductId} from 'nutshell-core/types';

import type {ProductPickerProductFragment as ProductPickerProductResult} from 'nutshell-graphql-types';

export type ProductPickerMarketPrice = {
    amount: string;
    isAvailable: boolean;
};

export type ProductPickerProduct = {
    id: ProductId;
    name: string;
    sku: string;
    category: {
        id: string;
        name: string;
    } | null;
    /** The market whose price data was requested for this product. */
    priceMarketId: MarketId | null;
    prices: Partial<Record<MarketId, ProductPickerMarketPrice>>;
};

export function toProductPickerProduct(
    result: ProductPickerProductResult,
    marketId?: MarketId
): ProductPickerProduct {
    const prices: ProductPickerProduct['prices'] = {};

    if (marketId && result.marketPrice) {
        prices[marketId] = {
            amount: String(result.marketPrice.amount),
            isAvailable: Boolean(result.isAvailable),
        };
    }

    return {
        id: result.product.id,
        name: result.product.name,
        sku: result.product.sku,
        category: result.product.category
            ? {
                  id: result.product.category.id,
                  name: result.product.category.name,
              }
            : null,
        priceMarketId: marketId ?? null,
        prices,
    };
}
